import { Link } from 'react-router';
import './BrandOnboardFooter.scss';
import { BrandOnboardFooterModel as model } from './model';
export const BrandOnboardFooter = () => {
	return (
		<div className='brand-onboard-footer'>
			<div className='onboard-footer-title-container'>
				<span className='footer-title'>{model.footerTitle}</span>
			</div>
			<div className='links-container'>
				<ul className='list-container'>
					<li>
						{model.viewText}{' '}
						<Link
							to={{
								pathname: model.onboardingGuideLink,
								search: `?section=beacon-hub-faq`
							}}
							className='title-container'
						>
							{model.onboardingGuideText}
						</Link>{' '}
					</li>
					<li>
						{model.viewOnBoardingText}{' '}
						<a href={model.viewOnBoardingLink} target='_blank' rel='noopener noreferrer'>
							{model.viewOnBoardingLinkText}
						</a>
					</li>
					<li>
						{model.learnMoreAboutText}{' '}
						<a href={model.newHopeNetworkLink} target='_blank' rel='noopener noreferrer'>
							{model.newHopeStandardsText}
						</a>
					</li>
					<li>
						{model.reachOutText}{' '}
						<a href={`mailto:${model.audienceLink}`} target='_blank' rel='noopener noreferrer'>
							{model.audienceText}
						</a>{' '}
						{model.onboardingConcernText}
					</li>
				</ul>
			</div>
		</div>
	);
};
